import React, {useState, useEffect} from 'react';
import {
    Container,
    Button,
    Menu,
    Grid,
    GridColumn,
    Icon,
    Header,
    Dropdown,
    MenuItem,
    Sidebar,
} from 'semantic-ui-react'

import withRouter from "../common/withRouter";
import {getLanguage} from "../slices/adapt";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";


const ClinicianForm = (props) => {
    const dispatch = useDispatch();
    const [translate, setTranslate] = useState("en")
    const [visible, setVisible] = useState(false);
    const [open, setOpen] = useState(false)
    const {language} = useSelector((state) => ({
        language: state.adapt.language,
    }));


    useEffect(() => {
        const params = new URLSearchParams(props.router.location.search);
        const translate = params.get("translate")
        setTranslate(translate || "en")
        dispatch(getLanguage())
    }, [dispatch])


    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
        setVisible(isMobile ? visible : false)
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    function isMobileDevice() {
        const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return regex.test(navigator.userAgent);
    }

    const isMobile = width <= 768

    if (isMobileDevice()) {
        // console.log("Mobile device detected");
    } else {
        // console.log("Desktop device detected");
    }
    let i18n = (language && language.data && language.data.languages && language.data.languages[translate].value) || {}
    document.title = i18n.about_us_menu || 'About';
    return (
        <React.Fragment>
            <Menu fixed='top' inverted
                  style={{background: "linear-gradient(90deg, rgba(11,89,223,1) 0%, rgba(24,122,229,1) 49%, rgba(68,225,249,1) 100%)"}}>
            </Menu>
            <Container style={{marginTop: 40, alignContent: "center"}}>
                <Grid doubling columns={2}
                      style={{alignContent: "right", marginTop:0}}>

                    <GridColumn floated='right' width={8} style={{
                        padding: 0,
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "right",
                    }}>

                        <Button
                            aria-label={i18n.clinician_form_button}
                            className={'menu_button'}
                            icon
                            labelPosition='left'
                            onClick={() => {
                                window.open(window.CONFIG.clinicianURL + "?translate=" + translate, "_self")
                            }}>
                            <Icon name='list alternate' size={"large"}/>
                            {i18n.clinician_form_button}</Button>
                        <Button.Group className={"language"}
                        >
                            <Button
                                aria-label={"Select Language"}
                                icon
                                labelPosition='left'
                                className={'language_button_active'}
                                onBlur={() => setTimeout(() => {
                                    setOpen(false)
                                }, 200)}
                                onClick={() => setOpen(!open)}>
                                <Icon name='world' size={"large"}/>
                                {translate === "en" ? "English" : 'Español'}</Button>
                            <Dropdown
                                open={open}
                                style={{marginLeft: 1}}
                                aria-label={"Select Language"}
                                className='button icon'
                                onBlur={() => setOpen(false)}
                                onClick={() => setOpen(!open)}
                            ><Dropdown.Menu>
                                {translate === "es" &&
                                    <Dropdown.Item
                                        aria-label={"Inglés"}
                                        as={Button}
                                        className={translate === "en" ? 'language_button_active' : "language_button"}
                                        onClick={() => {
                                            setTranslate("en")
                                        }}>Inglés
                                    </Dropdown.Item>
                                }
                                {translate === "en" &&
                                    <Dropdown.Item
                                        aria-label={"Spanish"}
                                        as={Button}
                                        className={translate === "es" ? 'language_button_active' : "language_button"}
                                        onClick={() => {
                                            setTranslate("es")
                                        }}>Spanish
                                    </Dropdown.Item>
                                }
                            </Dropdown.Menu>
                            </Dropdown>
                        </Button.Group>
                    </GridColumn>
                </Grid>
            </Container>
            <Container style={{marginTop: 20, alignContent: "center"}}>
                <Grid columns={2}
                      style={{padding: 20, alignContent: "center"}}>
                    <GridColumn width={1} style={{
                        padding: 0,
                        paddingTop: 15,
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Link to={"/?translate=" + translate}>
                            <Header as={'h4'} style={{cursor: "pointer"}}>
                                <span style={{color: "#0959DF"}}>ADAPT4</span>Change
                            </Header>
                        </Link>
                    </GridColumn>
                    <GridColumn floated='right'
                                width={isMobile ? 1 : 11} style={{
                        padding: 0,
                        paddingTop: 5,
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "right",
                    }}>

                        {isMobile ? <>

                            <Icon name={visible ? "times" : "bars"}
                                  size='large'
                                  checked={visible}
                                  onClick={() => setVisible(!visible)}/>

                        </> : null}
                        {isMobile ? null :
                            <Menu secondary floated='right'>
                                <Link to={"/resources?translate=" + translate}>
                                    <MenuItem
                                        content={i18n.resource_menu || "Resources"}
                                    />
                                </Link>
                                <Link to={"/about?translate=" + translate}>
                                    <MenuItem
                                        content={i18n.about_us_menu || 'About Us'}
                                    />
                                </Link>
                                <Link to={"/becomearesource?translate=" + translate}>
                                    <MenuItem
                                        content={i18n.become_resource_menu || 'Become a Resource'}
                                    />
                                </Link>
                            </Menu>}

                    </GridColumn>
                </Grid>
            </Container>
            <Sidebar.Pushable style={{border: "none"}}>
                <Sidebar
                    inverted
                    as={Menu}
                    animation='overlay'
                    direction='top'
                    vertical
                    onHide={() => setVisible(false)}
                    visible={visible}
                >
                    <Link to={"/resources?translate=" + translate}>
                        <MenuItem
                            content={i18n.resource_menu || "Resources"}
                        />
                    </Link>
                    <Link to={"/about?translate=" + translate}>
                        <MenuItem
                            content={i18n.about_us_menu || 'About Us'}
                        />
                    </Link>
                    <Link to={"/becomearesource?translate=" + translate}>
                        <MenuItem
                            content={i18n.become_resource_menu || 'Become a Resource'}
                        />
                    </Link>
                </Sidebar>
                <Sidebar.Pusher dimmed={visible}>
                    <Menu inverted
                          style={{backgroundColor: "#1E3766", paddingBottom: 50, paddingTop: 50}}>
                        <Container style={{display: "flex", flexDirection: "column"}}>
                            <div style={{display: "flex", flexDirection: "row", marginBottom: 0}}>

                            </div>
                            <Header as={'h4'} style={{
                                textAlign: "center",
                                color: "white",
                                letterSpacing: 2.5,
                                fontFamily: "Rockwell",
                                fontWeight: 400,
                                fontSize: isMobile ? 28 : 40
                            }}>
                                {i18n.about?.header}
                            </Header>
                        </Container>
                    </Menu>
                    <Container>
                        <div style={{
                            marginBottom: '3em',
                            // marginLeft: '3vw',
                            // marginRight: "3vw",
                            borderRadius: 20,
                            padding: isMobile ? 1 : 10,
                            backgroundColor: "white"
                        }}>
                            <br/>
                            <br/>
                            <br/>
                            <div
                                style={{
                                    whiteSpace: "pre-wrap",
                                    fontSize: 16,
                                    textAlign: "center"
                                }}>
                                {
                                    i18n.about?.who_we_are &&
                                    <div
                                        style={{
                                            whiteSpace: "pre-wrap",
                                            fontSize: 16,
                                            textAlign: "left"
                                        }}>

                                        <Header as={'h4'}
                                                style={{
                                                    textAlign: isMobile ? "center" : "left",
                                                    color: "#053b99"
                                                }}>
                                            {i18n.about.who_we_are}
                                        </Header>
                                        <span dangerouslySetInnerHTML={{__html: i18n.about.who_we_are_text}}/>

                                    </div>
                                }
                                <br/>
                                <br/>
                                {
                                    i18n.about?.what_we_do &&
                                    <div
                                        style={{
                                            whiteSpace: "pre-wrap",
                                            fontSize: 16,
                                            textAlign: "left"
                                        }}>

                                        <Header as={'h4'}
                                                style={{
                                                    textAlign: isMobile ? "center" : "left",
                                                    color: "#053b99"
                                                }}>
                                            {i18n.about.what_we_do}
                                        </Header>
                                        <span dangerouslySetInnerHTML={{__html: i18n.about.what_we_do_text}}/>

                                    </div>
                                }
                                <br/>
                                <br/>
                                {
                                    i18n.about?.our_philosophy &&
                                    <div
                                        style={{
                                            whiteSpace: "pre-wrap",
                                            fontSize: 16,
                                            textAlign: "left"
                                        }}>

                                        <Header as={'h4'}
                                                style={{
                                                    textAlign: isMobile ? "center" : "left",
                                                    color: "#053b99"
                                                }}>
                                            {i18n.about.our_philosophy}
                                        </Header>
                                        <span dangerouslySetInnerHTML={{__html: i18n.about.our_philosophy_text}}/>

                                    </div>
                                }
                                <br/>
                                <br/>
                                {
                                    i18n.about?.community_resources &&
                                    <div
                                        style={{
                                            whiteSpace: "pre-wrap",
                                            fontSize: 16,
                                            textAlign: "left"
                                        }}>

                                        <Header as={'h4'}
                                                style={{
                                                    textAlign: isMobile ? "center" : "left",
                                                    color: "#053b99"
                                                }}>
                                            {i18n.about.community_resources}
                                        </Header>
                                        <span dangerouslySetInnerHTML={{__html: i18n.about.community_resources_text}}/>

                                    </div>
                                }
                            </div>
                        </div>


                    </Container>
                </Sidebar.Pusher>
            </Sidebar.Pushable>


            <footer>
                <p>
                    <span className={"header"}>{i18n.footer && i18n.footer.header}</span>
                    <br/>
                    <br/>
                    <span className={"subheader"}>{i18n.footer && i18n.footer.content}</span>
                </p>
            </footer>

        </React.Fragment>
    );
};

export default withRouter(ClinicianForm);
